import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidebarSearchState {
  query: string;
}

const initialState: SidebarSearchState = {
  query: '',
};

const sidebarSearchSlice = createSlice({
  name: 'sidebarSearch',
  initialState,
  reducers: {
    setSearchQuery(state, action: PayloadAction<string>) {
      state.query = action.payload;
    },
    clearSearchQuery(state) {
      state.query = '';
    },
  },
});

export const { setSearchQuery, clearSearchQuery } = sidebarSearchSlice.actions;

export default sidebarSearchSlice.reducer;
